import { render, staticRenderFns } from "./TravelInterruption.vue?vue&type=template&id=546ce861&"
import script from "./TravelInterruption.vue?vue&type=script&lang=ts&"
export * from "./TravelInterruption.vue?vue&type=script&lang=ts&"
import style0 from "./TravelInterruption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports